import { BaseApi } from '@/providers';
import { getCaptchaToken } from '@/utils';

export interface IUploader {
  uploadFile: (file: File, cb: (file: File, id: string) => void) => Promise<void>;
}

class Uploader extends BaseApi implements IUploader {
  private async _getPresignedUrl(fileType: string): Promise<Response> {
    const token = await getCaptchaToken();
    return fetch(`${this.baseApiUrl}/quote/upload/`, {
      method: 'post',
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Recaptcha-Token': token,
      },
      body: JSON.stringify({
        token,
        type: fileType,
        ext: `.${fileType.split('/').pop() as string}`,
      }),
    });
  }

  public async uploadFile(file: File, cb: (file: File, id: string) => void): Promise<void> {
    try {
      const data = await this._getPresignedUrl(file.type).then(
        async (res): Promise<{ file: string; url: string }> => res.json()
      );

      await fetch(data.url, {
        method: 'put',
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': file.type,
        },
        body: file,
      });

      cb(file, data.file);
    } catch (error) {
      console.error(error);
    }
  }
}

export default new Uploader();
